export const GIVETAKETYPE_NONE = 0;
export const GIVETAKETYPE_STAFF = 1;
export const GIVETAKETYPE_DRIVER = 2;
export const GIVETAKETYPE_HIME = 3;
export const GIVETAKETYPE_USER = 4;

export const TYPE_NONE = 0;
export const TYPE_RESV_RECEIVE = 1;
export const TYPE_RESV_MONEYTEMP = 2;
export const TYPE_RESV_COLLECTBYDRIVER = 3;
export const TYPE_FIXHIME = 4;
